
export const reportRedditPixelTrial = (conversionId: string) => {
    if (typeof window.rdt === 'function') {
        window.rdt('track', 'Lead', { conversionId: conversionId });
    }
};


export const initRedditPixel = (email: string | null) => {
    if (!email) {
        return;
    }
    if (typeof window.rdt === 'function') {
        window.rdt('init', 't2_clk6qemp', {
            email: email
        });
    }
}